import { Reducer } from 'redux';
import {
  ECOMMERCE_ACCOUNT_FAILURE,
  ECOMMERCE_ACCOUNT_LOADED,
  ECOMMERCE_ACCOUNT_REQUEST
} from 'constants/ecommerceConstants';
import EcommerceState, { EcommerceInterface } from 'state/EcommerceState';

const ecommerceReducer: Reducer<EcommerceInterface> =
  (state: EcommerceInterface = EcommerceState, action) => {
    switch (action.type) {
      case ECOMMERCE_ACCOUNT_REQUEST:
        return { ...state, loading: true };
      case ECOMMERCE_ACCOUNT_LOADED:
        return { ...state, loading: false, account: action.payload };
      case ECOMMERCE_ACCOUNT_FAILURE:
        return { loading: false };
      default:
        return state;
    }
  };

export default ecommerceReducer;
